import { useNavigate } from "react-router-dom";

interface Props {
	title: string | undefined;
	subtitle: string | undefined;
	icon: string | undefined;
	route?: string;
	iconStyle: string;
	isCompleted: boolean;
	isCliccable: boolean;
}

const MacroStep: React.FC<Props> = (props) => {
	const { title, route, subtitle, icon, iconStyle, isCompleted, isCliccable } = props;

	const navigate = useNavigate();

	const handleClick = () => {
		if (isCliccable && route) navigate(route);
	};

	return (
		<div
			className={`d-flex text-white px-3 pb-4 ${isCliccable ? "cursor-pointer" : ""}`}
			onClick={handleClick}
		>
			<div className={`square-icon-shadow ${iconStyle}`}>
				<div className="square-icon-container">
					<i className={`fas ${icon} square-icon`}></i>
					{isCompleted && (
						<div className="state-macro-step">
							<i className="fas fa-check" style={{ fontSize: "0.7rem", color: "#0472f6" }}></i>
						</div>
					)}
				</div>
			</div>

			<div className="d-flex flex-column">
				<span className="font-weight-bold text-white">{title}</span>
				<span className="light-gray">
					<small>{subtitle}</small>
				</span>
			</div>
		</div>
	);
};
export default MacroStep;
